import { render, staticRenderFns } from "./WorkforceDetailView.vue?vue&type=template&id=ce54f996&"
import script from "./WorkforceDetailView.vue?vue&type=script&lang=js&"
export * from "./WorkforceDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports